import api from '../api'

export default {
    namespaced: true,
    state: {
        redPack: {// 牌局内红包雨
            countLimit: 0,
            status: 0
        },
        firstCharge: {// 首充红包
            status: 0
        },
        firstChargeClubList: {// 首充红包的俱乐部
            beanList: [],
            total: 0
        },
        firstChargeConfigClubList: {// 首充红包配置俱乐部
            beanList: [],
            total: 0
        },
        horseRaceLamp: {// 跑马灯状态
            status: 0,
            kdou: 0
        }
    },
    mutations: {
        setStateRedPack(state, info) {
            state.redPack = info
        },
        setStateFirstCharge(state, info) {
            state.firstCharge = info
        },
        setStateFirstChargeClubList(state, info) {
            state.firstChargeClubList = info
        },
        setStateFirstChargeConfigClubList(state, info) {
            state.firstChargeConfigClubList = info
        },
        setStateHorseRaceLamp(state, info) {
            state.horseRaceLamp = info
        }
    },
    actions: {
        getRedPack({commit}) {
            return api.post('/activity/redPack', '天降红包').then(res => {
                commit('setStateRedPack', res.data)
            })
        },
        updateRedPackLimit(store, params) {
            return api.post('/activity/redPackLimit', '修改天降红包限额度', params)
        },
        updateRedPackStatus(store, params) {
            return api.post('/activity/redPackSwitch', '修改天降红包状态', params)
        },
        getRedPackTotal(store, params) {
            return api.post('/activity/redPackTotalData', '天降红包统计查询', params)
        },
        getFirstChargeInfo(store, params) {
            return api.post('/activity/user/first/charge/info', '玩家首充红包活动信息', params)
        },
        getFirstChargeTotal(store, params) {
            return api.post('/activity/user/first/charge/statisticsByDate', '玩家首充红包统计查询', params)
        },
        getFirstCharge({commit}) {
            return api.post('/activity/configs/club/info', '指定俱乐部首充活动 - 信息').then(res => {
                commit('setStateFirstCharge', res.data)
            })
        },
        updateFirstChargeStatus(store, params) {
            return api.post('/activity/configs/club/updateStatus', '指定俱乐部首充活动 - 开关', params)
        },
        getFirstChargeClubList({commit}, params) {
            return api.post('/activity/club/config/configuredList', '已配置的活动俱乐部列表', params).then(res => {
                commit('setStateFirstChargeClubList', res.data)
            })
        },
        getFirstChargeConfigClubList({commit}, params) {
            return api.post('/activity/club/config/tribe/club/list', '查询俱乐部列表', params).then(res => {
                commit('setStateFirstChargeConfigClubList', res.data)
            })
        },
        updateFirstChargeClubList(store, params) {
            return api.post('/activity/club/config/save', '保存俱乐部', params)
        },
        getHorseRaceLampRecord() {
            return api.post('/horseracelamp/grand/rewards/records/query', '跑马灯游戏大奖记录查询')
        },
        getHorseRaceLampTotal(store, params) {
            return api.post('/horseracelamp/rewards/records/query', '跑马灯游戏获奖记录统计', params)
        },
        getHorseRaceLamp({commit}) {
            return api.post('/horseracelamp/status/query', '跑马灯游戏状态查询').then(res => {
                commit('setStateHorseRaceLamp', res.data)
            })
        },
        updateHorseRaceLampStatus({dispatch}, params) {
            return api.post('/horseracelamp/switchStatus', '开启/关闭跑马灯游戏', params).then(() => {
                dispatch('getHorseRaceLamp')
            })
        },
        addHorseRaceLampAccount({dispatch}, params) {
            return api.post('/horseracelamp/account/add', '跑马灯奖池注入', params).then(()=>{
                dispatch('getHorseRaceLamp')
            })
        },
        reduceHorseRaceLampAccount({dispatch}, params) {
            return api.post('/horseracelamp/account/reduce', '跑马灯奖池减少', params).then(()=>{
                dispatch('getHorseRaceLamp')
            })
        }
    }
}